import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Volumes from './Volumes';
import Assessment from './Assessment';
import Weighing from './Weighing';
import Stats from './Stats';
import Invoices from './Invoices';
import ReAssessment from './ReAssessment';
import Stock from './Stock';
import Offers from './Offers';
import Vehicles from './Vehicles';
import Sales from './Sales';
import AllVolumes from './AllVolumes';
import CostsPerCustomer from './CostsPerCustomer';
import SalesStock from './SalesStock';
import CostsPerTerms from './CostsPerTerms';
import OfferPackages from "./OfferPackages";
import DionysosVolumes from "./DionysosVolumes";
import ValidShelves from "./ValidShelves";
import Quarries from "./Quarries";
import IncomingDeliveries from "./IncomingDeliveries";
import AggregateShipments from "./AggregateShipments";
import Users from "./Users";
import CheckIns from "./CheckIns";
import Machines from "./Machines";
import Faults from "./Faults";
import MachineMap from "./MachineMap";
import LiveMachineMap from "./LiveMachineMap";
import LiveFaults from "./LiveFaults";
import Schedules from "./Schedules";
import EssSettings from "./EssSettings";
import PhoneCenter from "./PhoneCenter";
import MachineTypes from "./MachineTypes";

const Dashboard = () => {

    const [showSidebar, setShowSidebar] = useState(true);

    return <Routes>
        <Route exact path="/volumes" element={<Volumes />} />
        <Route exact path="/dionysos" element={<DionysosVolumes />} />
        <Route exact path="/shelves" element={<ValidShelves />} />
        <Route exact path="/quarries" element={<Quarries />} />
        <Route exact path="/assessment" element={<Assessment />} />
        <Route exact path="/reassessment" element={<ReAssessment />} />
        <Route exact path="/stock" element={<Stock />} />
        <Route exact path="/weighing" element={<Weighing />} />
        <Route exact path="/stats" element={<Stats />} />
        <Route exact path="/invoices" element={<Invoices />} />
        <Route exact path="/offers" element={<Offers />} />
        <Route exact path="/offerPackages" element={<OfferPackages />} />
        <Route exact path="/vehicles" element={<Vehicles />} />
        <Route exact path="/sales" element={<Sales />} />
        <Route exact path="/allVolumes" element={<AllVolumes />} />
        <Route exact path="/costs" element={<CostsPerCustomer />} />
        <Route exact path="/salesStock" element={<SalesStock />} />
        <Route exact path="/termPrices" element={<CostsPerTerms />} />
        <Route exact path="/incoming-deliveries" element={<IncomingDeliveries />} />
        <Route exact path="/aggregate-shipments" element={<AggregateShipments />} />
        <Route exact path="/users" element={<Users />} />
        <Route exact path="/ess-settings" element={<EssSettings />} />
        <Route exact path="/phone-center" element={<PhoneCenter />} />
        <Route exact path="/check-ins" element={<CheckIns />} />
        <Route exact path="/machine-types" element={<MachineTypes />} />
        <Route exact path="/machines" element={<Machines />} />
        <Route exact path="/faults" element={<Faults />} />
        <Route exact path="/live-faults" element={<LiveFaults />} />
        <Route exact path="/live-damages" element={<LiveFaults />} />
        <Route exact path="/machine-map" element={<MachineMap />} />
        <Route exact path="/live-machines" element={<LiveMachineMap />} />
        <Route exact path="/machine-map-split" element={<LiveMachineMap />} />
        <Route exact path="/schedules" element={<Schedules />} />
    </Routes>
};

export default Dashboard;